import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { PolicyChangeStatus } from '@/models/policyChange'
import { STAFF_STATUS_LABELS } from './endorsementCopy'

const BADGES: Partial<Record<PolicyChangeStatus, BadgeVariant>> = {
  [PolicyChangeStatus.SUBMITTED]: 'default',
  [PolicyChangeStatus.WITH_CARRIER]: 'default',
  [PolicyChangeStatus.ACCEPTED]: 'default',
  [PolicyChangeStatus.BOUND]: 'default',
  [PolicyChangeStatus.POLICY_UPDATED]: 'default',
  [PolicyChangeStatus.NEEDS_INFO]: 'warning',
  [PolicyChangeStatus.QUOTE_READY]: 'warning',
  [PolicyChangeStatus.COMPLETE]: 'success',
}

/** "2 · Review": the step a request is on and what it waits for; brand when it waits for staff. */
export function EndorsementStepBadge({ status, step }: { status: PolicyChangeStatus; step: number }) {
  return (
    <Badge variant={BADGES[status] ?? 'secondary'}>
      {step} · {STAFF_STATUS_LABELS[status]}
    </Badge>
  )
}
